export const STORAGE_KEYS = {
  PERSIST_ROOT: 'root',
  REMEMBER_EMAIL: 'remember_email',
};
